import './App.css';
import RootComponent from './root/RootComponent.js'

function App() {
  return (
    <div className="App">
      <RootComponent />
    </div>
  );
}

export default App;
